/**
 * @fileoverview Shared unit-conversion constants.
 *
 * The in-browser minimization engine works in kJ/mol, while BMaps displays
 * kcal/mol. The conversion factor (4.184 kJ per kcal) was duplicated across
 * `chemistry/LocalMinimizer/localMinimize.js` and `model/energyinfo.js`; this
 * module is the single source of truth so both importers stay bit-identical.
 */

/** kcal/mol -> kJ/mol (the thermochemical calorie: 1 kcal == 4.184 kJ). */
export const KCAL_TO_KJ = 4.184;

/** kJ/mol -> kcal/mol. The reciprocal of {@link KCAL_TO_KJ}. */
export const KJ_TO_KCAL = 1 / KCAL_TO_KJ;
